// src/constants/colors.js
const PALETTE = {
    // Nova paleta do cliente:
    primary: "#152a34", // Azul Escuro (Para botões principais e textos de destaque)
    secondary: "#688075", // Verde (Para hover/ações secundárias)
    accent: "#b99a52", // Dourado (Para preço e destaque visual)

    neutrals: {
        background: "#f6f4f1", // Bege (Para o fundo da página)
        surface: "#f9fafb", // Branco Suave (Para o fundo de cards)
        text: "#1f2937", // Texto Escuro
        muted: "#6b7280", // Texto Secundário
    },

    states: {
        success: "#10b981",
        warning: "#facc15",
        error: "#ef4444",
        info: "#3b82f6",
    },
};

module.exports = { PALETTE };